import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CurrenciesService } from 'src/app/api/currencies.service';
import { Currency } from 'src/app/models/currency';
import { CryptocurrencyAddress } from 'src/app/models/cryptocurrency-address';
import { ExchangeTransactionService } from 'src/app/api/exchange-transaction.service';
import { ExchangeCoinDepositAddress } from 'src/app/models/exchange-transaction';

@Component({
  selector: 'crypto-address',
  templateUrl: './crypto-address.component.html',
  styleUrls: ['./crypto-address.component.scss']
})
export class CryptoAddressComponent implements OnInit, OnChanges {
  @Input() code: string;
  @Input() showTitle = true;

  currency: Currency;
  data: ExchangeCoinDepositAddress;

  loading = false;
  error: string = null;

  allowApiCalls = false;
  showLegacyAddress = false;

  constructor(
    private currenciesService: CurrenciesService,
    private exchangeTransactionService: ExchangeTransactionService
  ) { }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    this.getCurrencyData();
    this.getData();
  }

  getCurrencyData() {
    if (!this.code || !this.allowApiCalls) { return; }
    this.currenciesService.getCryptoHash().subscribe(response => {
      this.currency = response[this.code];
    });
  }

  getData() {
    if (!this.code || !this.allowApiCalls) { return; }
    this.loading = true;
    this.error = null;
    this.data = null;
    this.exchangeTransactionService.getDepositAddress(this.code).subscribe(response => {
      this.loading = false;
      this.data = response;
    }, err => {
      this.loading = false;
      this.error = err.errors[0].message;
    });
  }

  onAgreements() {
    this.allowApiCalls = true;
    this.getCurrencyData();
    this.getData();
  }

  toggleLegacyAddress() {
    this.showLegacyAddress = !this.showLegacyAddress;
  }

  getAddress() {
    if (this.data && this.data.address) {
      return this.data.address.address ? this.data.address.address : this.data.address.legacyAddress;
    }

    return '';
  }
}
